import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.addUpperCloseButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.close && this.close(...args)))
          }, _toDisplayString(_ctx.$t('general.close')), 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("iframe", {
      class: "flex-grow-1",
      src: this.src,
      ref: "iframe"
    }, null, 8, _hoisted_4)
  ]))
}